/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { SurveyJobLevel } from '../models/SurveyJobLevel';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class SurveyJobLevelService {

    /**
     * Get survey job level
     * @returns SurveyJobLevel Success
     * @throws ApiError
     */
    public static getSurveyJobLevel({
        surveyJobLevelId,
    }: {
        /**
         * Survey Job Level ID
         */
        surveyJobLevelId: string,
    }): CancelablePromise<SurveyJobLevel> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/surveyJob/level/{surveyJobLevelId}',
            path: {
                'surveyJobLevelId': surveyJobLevelId,
            },
            errors: {
                400: `Validation error`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `The specified resource was not found`,
            },
        });
    }

}
